import {combineReducers} from 'redux'
import ModalReducer from "./ModalReducer";

const RootReducer = combineReducers({
    modal: ModalReducer,
});

export default RootReducer;
